export default __webpack_public_path__ + "static/dacha-main-4c1f1c3b61a9d92a66bbaa7d56d0d878.png";